import clsx from 'clsx';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { SHOP_ALL_AISLE } from 'constants/shop';
import Tag from 'honeydew/Tag';
import { getAislePath } from 'utils/pathUtils';

const styles = {
    navList: 'mt-20 space-y-10',
    navLink: 'block p-10',
    navLinkNew: 'flex items-center gap-15',
    navLinkActive: 'bg-lime if:bg-strawberry',
    navDivider: 'my-20 -mx-20 h-[3px] border-none bg-lime if:bg-strawberry',
    navHeadline: 'text-body-lg font-grotesk-bold uppercase',
};

function DesktopShopNavigation({ aisles, inStockAllItemsCount }) {
    const allItemsAisle = {
        ...SHOP_ALL_AISLE,
        inStockCount: inStockAllItemsCount,
    };

    const aisleItems = [allItemsAisle, ...aisles].map((aisle) => (
        <li key={aisle.id}>
            <NavLink
                to={aisle.url || getAislePath(aisle.name)}
                className={({ isActive }) => clsx(styles.navLink, { [styles.navLinkActive]: isActive })}
            >
                {aisle.name} <span className="text-grey">({aisle.inStockCount})</span>
            </NavLink>
        </li>
    ));

    return (
        <nav className="mb-80">
            <h3 className={styles.navHeadline}>Curated</h3>
            <ul className={styles.navList}>
                <li>
                    <NavLink
                        to="/shop"
                        end
                        className={({ isActive }) => clsx(styles.navLink, { [styles.navLinkActive]: isActive })}
                    >
                        Weekly Picks
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/shop/browse/misfits+perks"
                        className={({ isActive }) =>
                            clsx(styles.navLink, styles.navLinkNew, { 'bg-brand-secondary': isActive })
                        }
                    >
                        Shop with Points
                        <Tag bgColor="special" variant="dark">
                            NEW
                        </Tag>
                    </NavLink>
                </li>
            </ul>
            <hr className={styles.navDivider} />
            <h3 className={styles.navHeadline}>Aisles</h3>
            <ul className={styles.navList}>{aisleItems}</ul>
        </nav>
    );
}

DesktopShopNavigation.propTypes = {
    aisles: PropTypes.arrayOf(PropTypes.shape({})),
};

DesktopShopNavigation.defaultProps = {
    aisles: [],
};

export default DesktopShopNavigation;
